module.exports = __webpack_public_path__ + "media/images/flags/32/South-Africa-8f2d2c6b9953e88ccb0d37e23a342b1f.png";